"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cccisdLoadGlobalLibrary = _interopRequireDefault(require("cccisd-load-global-library"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** cccisd-dataviz provides a library for creating charts and graphs. */
var DataViz =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataViz, _React$Component);

  function DataViz() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataViz);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataViz)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      wrapper: null
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount",
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var packages;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _cccisdLoadGlobalLibrary.default)('google', '//www.gstatic.com/charts/loader.js');

            case 2:
              packages = _this.props.allowEdit ? ['corechart', 'charteditor'] : ['corechart'];
              window.google.charts.load('current', {
                packages: packages
              });
              window.google.charts.setOnLoadCallback(function () {
                _this.createWrapper();

                _this.drawChart();
              });
              window.addEventListener('resize', _this.handleResize);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "getchart", function () {
      if (!_this.state.wrapper) {
        return null;
      }

      return _this.state.wrapper.getChart();
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      if (_this.resizeTimer) {
        clearTimeout(_this.resizeTimer);
      }

      _this.resizeTimer = setTimeout(_this.drawChart, 100);
    });

    _defineProperty(_assertThisInitialized(_this), "createWrapper", function () {
      if (!window.google) {
        return;
      }

      _this.setState({
        wrapper: new window.google.visualization.ChartWrapper(_this.props.chartData)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showEditor", function (e) {
      e && e.preventDefault();
      var chartEditor = new window.google.visualization.ChartEditor();
      window.google.visualization.events.addListener(chartEditor, 'ok', _this.editorDone.bind(_assertThisInitialized(_this), chartEditor));
      chartEditor.openDialog(_this.state.wrapper, {});
    });

    _defineProperty(_assertThisInitialized(_this), "editorDone", function (c, e) {
      if (_this.props.onEdit) {
        _this.props.onEdit(c.getChartWrapper().toJSON());
      }

      _this.setState({
        wrapper: c.getChartWrapper()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drawChart", function () {
      if (!window.google || !_this.state.wrapper) {
        return;
      }

      _this.state.wrapper.draw(_this.refs.chart);
    });

    _defineProperty(_assertThisInitialized(_this), "clearChart", function () {
      if (!window.google || !_this.state.wrapper) {
        return;
      }

      _this.state.wrapper.getChart().clearChart();
    });

    return _this;
  }

  _createClass(DataViz, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.state.wrapper && window.google && this.props.chartData) {
        this.createWrapper();
      }

      this.drawChart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      this.clearChart();
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.props.containerClass,
        style: {
          position: 'relative'
        }
      }, this.props.allowEdit && _react.default.createElement("a", {
        className: "btn btn-default btn-sm ".concat(_style.default.editButton),
        onClick: this.showEditor
      }, "Edit"), _react.default.createElement("div", {
        ref: "chart"
      }));
    }
  }]);

  return DataViz;
}(_react.default.Component);

exports.default = DataViz;

_defineProperty(DataViz, "propTypes", {
  /** Wrapper for required chart information including <ul><li>'chartType' - (<i>required</i>)</li><li>'dataTable' or 'dataSourceUrl' - (<i>required</i>)</li><li>'query' - (filter data)</li><li>'refreshInterval' - (how often dataSourceUrl is called)</li><li>'view' - filter for underlying data <i>see</i> https://developers.google.com/chart/interactive/docs/reference#dataview-class</ul> */
  chartData: _propTypes.default.object.isRequired,

  /** Show a button that will allow the user to edit the appearance of the chart. */
  allowEdit: _propTypes.default.bool,

  /** The class for the wrapper div that contains the chart.  */
  containerClass: _propTypes.default.string,

  /** A function called when chart is edited. */
  onEdit: _propTypes.default.func
});

_defineProperty(DataViz, "defaultProps", {
  allowEdit: false,
  containerClass: ''
});